import { LoadingSpinnerProps } from '@zeiss/beyond-online-react';

import { PageLoaderContent } from './PageLoaderContent';
import { PageLoaderLayout } from './PageLoaderLayout';

export interface WithLayoutProps extends LoadingSpinnerProps {
  footer: React.ReactNode;
  productTitle: string;
  withLayout: boolean;
}

interface WithoutLayoutProps extends LoadingSpinnerProps {
  footer?: never;
  productTitle?: never;
  withLayout?: never;
}

type BasicPageLoaderProps = WithLayoutProps | WithoutLayoutProps;

export const PageLoader = (props: BasicPageLoaderProps) => {
  const { footer, productTitle, withLayout = false } = props;

  if (withLayout) {
    return (
      <PageLoaderLayout footer={footer} productTitle={productTitle}>
        <PageLoaderContent {...props} />
      </PageLoaderLayout>
    );
  }

  return <PageLoaderContent {...props} />;
};
